import { Settings } from "lucide-react";

// Components
import IncineratorData from "./IncineratorData";
import EmissionAnalysisChart from "./EmissionAnalysisChart";
import FuelConsAnalysisChart from "./FuelConsAnalysisChart";

const MachineryIncinerator = ({ }) => {
    return (
        <div className="space-y-6">
            <div className="flex gap-6">
                <div className="flex-1">
                    <IncineratorData />
                </div>
            </div>

            <div className="bg-white rounded-lg">
                <div className="px-6 pt-5 pb-3 border-b border-gray-100 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
                            <Settings className="w-5 h-5" />
                        </div>
                        <h2 className="text-lg font-semibold text-gray-800 tracking-tight">
                            Emission Analytics
                        </h2>
                    </div>
                </div>
                <div className="p-5">
                    <EmissionAnalysisChart />
                </div>
            </div>

            <div className="bg-white rounded-lg">
                <div className="px-6 pt-5 pb-3 border-b border-gray-100 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
                            <Settings className="w-5 h-5" />
                        </div>
                        <h2 className="text-lg font-semibold text-gray-800 tracking-tight">
                            Fuel Consumption
                        </h2>
                    </div>
                </div>
                <div className="p-6">
                    <FuelConsAnalysisChart />
                </div>
            </div>
        </div>
    );
};

export default MachineryIncinerator;